export enum HistoryDetailsType {
  OrderHeadInfo = "OrderHeadInfo",
  InsuranceCancellationInfo = "InsuranceCancellationInfo",
  InsuranceSubsequentTaxInfo = "InsuranceSubsequentTaxInfo",
  OrderItemToInsuranceInfo = "OrderItemToInsuranceInfo",
  String = "HistoryDetailsString",
  IdString = "HistoryDetailsIdString",
}
